import { API } from 'aws-amplify';
import { vuexErrorHandler } from '@switchsystems/coactive-vue-lib';

const API_NAME = 'recruitment';
const API_VERSION = '/v1';

const modulestate = () => ({
  cachedJobs: [],
});
const getters = {
  cachedJobs: (state) => state.cachedJobs,
};
const mutations = {
  cachedJobs(state, jobs) {
    state.cachedJobs = jobs;
  },
};

/*
async function getApiInit() {
  return {
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
    },
  };
}
*/

const actions = {
  async fetchJobOpportunities(context, payload) {
    const myInit = {};

    // payload contains filter/sort/pagination options.
    if (payload) {
      myInit.queryStringParameters = {
        page: payload.page,
        pageSize: payload.pageSize,
      };
      if (Object.prototype.hasOwnProperty.call(payload, 'filter')) {
        // payload.filter might be undefined. Check before adding param.
        if (payload.filter && payload.filter.length !== 0) {
          myInit.queryStringParameters.filter = JSON.stringify(payload.filter);
        }
      }
    }
    return API.get(API_NAME, `${API_VERSION}/job-opportunities/`, myInit)
      .then((response) => response)
      .catch((error) => vuexErrorHandler(error));
  },
  async fetchJobOpportunity(context, params) {
    return API.get(API_NAME, `${API_VERSION}/job-opportunities/${params.ref}`)
      .then((response) => response)
      .catch((error) => vuexErrorHandler(error));
  },
};

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state: modulestate,
};
